import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {amCharts_v4_date_line_template} from "./amCharts_v4_date_line_template";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {autoRefresh_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/autoRefresh_template";
import {chunkObservableArray} from "../../utils/Helpers";
import {watchlist} from "../../modules/watchlist";

declare var ko: any;

export class watchlist_template extends vnTemplate {

    static REQUEST_BATCH_SIZE = 10

    protected watchlistChart: amCharts_v4_date_line_template;
    protected shortTermReportTooltip: infoButton_template;
    protected shortTermReportTooltipContent;
    protected shortTermReportPopupTooltip: infoButton_template;
    protected shortTermReportPopupTooltipContent;
    protected shortTermReportChart: amCharts_v4_date_line_template;

    protected autoRefresh: autoRefresh_template;

    protected getTemplateHtml(): string{

        return `                 
             <div data-bind="visible: !watchlistEmpty()">
                <div class="w-form-group" style="margin-bottom: 0">         
                     <div class="form-group w-justify sub-header watchlist-header">   
                        <div class="w-left">
                            <div class="form-check-inline width-auto">
                               <input type="radio" name="chartView" id="view_24hour" value="day" data-bind="checked: chartsRange(), event: {change : onClick1DayView}"/>
                               <label class="form-label" for="view_24hour">24 Hour View</label>
                            </div>   
                            <div class="form-check-inline width-auto">
                                <input type="radio" name="chartView" id="view_7day" value="week" data-bind="checked: chartsRange(), event: {change : onClick7DayView}"/>
                                <label  class="form-label" for="view_7day">7 Day View</label>   
                            </div>
                            <div style="margin-bottom: -1.5rem;">
                                <span class="w-tooltips-adv pos-bottom short">
                                       ` + this.shortTermReportTooltip.getHtmlBuild() + `
                                </span> 
                            </div>                            
                        </div>
                        <div class="w-center w-faux-legend">
                            <button type="button" class="faux-legend views" data-bind="css: {'inactive' : hideChartLines().indexOf('viewCount') >= 0}, event: { click: toggleChartLines.bind($data, 'viewCount') }">Views</button>
                            <button type="button" class="faux-legend visits" data-bind="css: {'inactive' : hideChartLines().indexOf('visitCount') >= 0}, event: { click: toggleChartLines.bind($data, 'visitCount') }">Visits</button>
                            <button type="button" class="faux-legend engagments" data-bind="css: {'inactive' : hideChartLines().indexOf('depthMarkerCount') >= 0}, event: { click: toggleChartLines.bind($data, 'depthMarkerCount') }">Engagements</button>
                        </div>
                        <div class="w-right">
                            <button title="Copy Watchlist to Clipboard" type="button" class="btn icon only-icon i-link" data-bind="event: { click: onClickCreateShareUrl }" style="margin-bottom: 0"></button>
                        ` + this.autoRefresh.getHtmlBuild() + `
                        </div>
                    </div>
                </div>
                
                <div class="watchlist-dashboard" id="watchlistDashboard">
                    <ul class="d-content d-article" data-bind="foreach: watchlist, childrenComplete : handleDragAndDrop($element, watchlist, '.card-watchlist')" id="watchlistList">
                        <li class="list-card card-watchlist" data-bind="attr : {id : $data.article.id}">
                            <div class="card-header">
                                <div class="w-left">
                                    <span data-bind="visible: !$parent.isFromURL()" class="icon i-drag"></span>
                                    <image data-bind="attr:{src: $data.article.featuredImage.url}"/>
                                </div> 
                                <div class="w-center" data-bind="event: { click: $parent.onClickViewArticle }">
                                    <div class="card-list-title article-title" data-bind="text: $data.article.title"></div>
                                    <span class="date" data-bind="text: 'Published on: ' + $data.publishDate.toISOString().split('T')[0]"></span>
                                </div>
                                <div class="w-right" data-bind="visible: !$parent.isFromURL()">
                                    <span class="icon i-close-2" data-bind="event: {click : $parent.onClickRemoveFromWatchlist}"></span>
                                </div>
                            </div>
                            <div class="card-content" data-bind="event: { click: $parent.onClickShowChart }">
                                <div class="svg-wrapper" data-bind="attr: { 'id': 'trend-' + $data.article.id, 'data-id-article': $data.article.id  }" style="position: relative"></div>
                            </div>
                        </li>    
                    </ul>
                </div>
                
                <div class="w-lightbox light-theme performance-pop-up" id="watchlist-chart-popup">
                <div class="lightbox-content">                
                    <div class="w-form lightbox-form" style="width: 50vw">
                        <div class="form-header">
                          <h3 class="form-title">Performance
                              <span class="w-tooltips-adv pos-bottom short"  style="margin-left: 1rem;margin-top: -1rem;">
                                   ` + this.shortTermReportPopupTooltip.getHtmlBuild() + `
                              </span> 
                          </h3>
                          <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickHideChart }"></button>
                        </div>
                        <div class="form-body">
                        <div class="sentinel-logo"></div>
                            <div class="form-group w-justify">                        
                                <div class="w-left">
                                    <div class="form-group row" style="margin: 0">
                                         <div class="form-check-inline width-auto">
                                            <input type="radio" name="ShortTermReportView" id="view_24hour_str" value="day" data-bind="checked: shortTermReportRange(), event: {change : onClick1DayViewSTR}"/>
                                            <label class="form-label" for="view_24hour_str">24 Hour View</label>
                                         </div>   
                                         <div class="form-check-inline width-auto">
                                             <input type="radio" name="ShortTermReportView" id="view_7day_str" value="week" data-bind="checked: shortTermReportRange(), event: {change : onClick7DayViewSTR}"/>
                                             <label  class="form-label" for="view_7day_str">7 Day View</label>   
                                         </div>
                                    </div>
                                </div>
                                <div class="w-center">
                                    <div id="legenddiv"></div>
                                </div>
                                <div class="w-right">
                                    <button type="button" data-bind="click: onClickRefreshSTR" class="btn icon only-icon i-refresh"> 
                                    </button>
                                </div>
                            </div>
                            <div class="form-group" id="shortTermReportFormGroup" style="height: 470px">                             
                                <div>                                                    
                                    ${this.shortTermReportChart.getHtmlBuild()}
                                </div>
                            </div>
                        </div>                    
                    </div>
                </div>
            </div>
                
                  <div style="opacity: 0">
                    ${this.watchlistChart.getHtmlBuild()}
                 </div>
             </div>
             
             <div style="background: none;box-shadow: none;" class="w-form center" data-bind="visible: watchlistEmpty()"><h1 class="page-title">Your watchlist is empty. Add items to your watchlist to view performance data.</h1></div>
            `;
    }

    protected initPartial():void{

        this.watchlistChart = new amCharts_v4_date_line_template("amCharts_v4_date_watchlist_line_template", this.getTemplateViewModel(), this.caller as watchlist);
        this.watchlistChart.setXAxisRotation(-90);
        this.watchlistChart.setXAxisFontSize(14);

        this.shortTermReportTooltip = new infoButton_template('shortTermReportTooltip', this.getTemplateViewModel(), this.caller)
        this.shortTermReportTooltip.setTitle('Performance');
        this.shortTermReportTooltipContent = `<ul>
        <li>Views count each load of an article, including if it is loaded as part of the infinite scroll experience.</li>
        <li>Visits count each load of an article where a user navigated from an external source.</li>
        <li>Engagements indicates the percentage of users that navigated to a depth of at least 1600 pixels in the article.</li> </ul>`
        this.shortTermReportTooltip.setContent(this.shortTermReportTooltipContent);

        this.shortTermReportPopupTooltip = new infoButton_template('shortTermReportPopupTooltip', this.getTemplateViewModel(), this.caller )
        this.shortTermReportPopupTooltip.setTitle('Performance');
        this.shortTermReportPopupTooltipContent = `<ul>
        <li>Views count each load of an article, including if it is loaded as part of the infinite scroll experience.</li>
        <li>Visits count each load of an article where a user navigated from an external source.</li>
        <li>Engagements indicates the percentage of users that navigated to a depth of at least 1600 pixels in the article.</li> </ul>`
        this.shortTermReportPopupTooltip.setContent(this.shortTermReportPopupTooltipContent);

        this.shortTermReportChart = new amCharts_v4_date_line_template("amCharts_v4_date_STRList_line_template", this.getTemplateViewModel(), this.caller);
        this.shortTermReportChart.setXAxisRotation(-90);
        this.shortTermReportChart.setXAxisFontSize(14);

        this.autoRefresh = new autoRefresh_template('autoRefresh', this.getTemplateViewModel(), this.caller as watchlist);
        this.autoRefresh.setToggleAutoRefresh(false)
        this.autoRefresh.setRefreshFrequency(1000)
    }

    protected getTemplateName(): string{

        return "watchlist_template";
    }

    protected buildViewModel(): any{

        const viewModel = {
            watchlist: ko.observableArray([]),
            watchlistIsLoaded : ko.observable(false),
            isFromURL: ko.observable(false),
            articles: ko.observableArray([]),
            chartsRange: ko.observable("day"),
            lastRefreshedCounter: ko.observable(0),
            hideChartLines: ko.observable([]),
            shortTermReportTooltip: ko.observable(null),
            shortTermReportPopupTooltip: ko.observable(null),
            watchlistEmpty: ko.observable(false),
            shortTermReportIdArticle: ko.observable(),
            shortTermReportRange: ko.observable("day"),
            batches: ko.observableArray([]),
            currentBatch: ko.observable(0),
            onClick7DayView: () => {
                this.onClick7DayView();
            },
            onClick1DayView: () => {
                this.onClick1DayView();
            },
            onClickRefresh: () => {
                this.onClickRefresh();
            },
            onClickCreateShareUrl: () => {
                this.onClickCreateShareUrl();
            },
            onClickRemoveFromWatchlist: (data, event) => {
                this.onClickRemoveFromWatchlist(data);
            },
            onClickViewArticle: (data, event) => {
                this.onClickViewArticle(data, event);
            },
            toggleChartLines: (value, data, event) => {
                this.toggleChartLines(value);
            },
            onClick7DayViewSTR: (value, data, event) => {
                this.onClick7DayViewSTR();
            },
            onClick1DayViewSTR: () => {
                this.onClick1DayViewSTR();
            },
            onClickRefreshSTR: () => {
                this.onClickRefreshSTR();
            },
            onClickShowChart: (data) => {
                this.onClickShowChart(data);
            },
            onClickHideChart: () => {
                this.onClickHideChart();
            },
            handleDragAndDrop: (element, currentObservableArray, childrenSelector) => {
                this.handleDragAndDrop(element, currentObservableArray ,childrenSelector)
            }
        };

        viewModel.watchlist.subscribe((changes) => {
            if(viewModel.watchlistIsLoaded()){
                //We subscribe to drag and drop only!
                for (let i = 0; i < changes.length; i++) {
                    const change = changes[i];
                    if (change && (change!.moved !== -1)) {
                        this.caller.editWatchlistOrder(viewModel.watchlist());
                        break;
                    }
                }
            }
        }, null, 'arrayChange');

        return viewModel;
    }

    public getViewModelForRequest(){

        return{
            articles : this.getTemplateViewModel().articles,
            isFromURL : this.getTemplateViewModel().isFromURL,
            chartsRange: this.getTemplateViewModel().chartsRange,
            hideChartLines: this.getTemplateViewModel().hideChartLines(),
        }
    }

    public getViewModelForBatchRequest(articles : any){
        return  {
            articles : articles,
            isFromURL : ko.observable(true),
            chartsRange: this.getTemplateViewModel().chartsRange,
            hideChartLines: this.getTemplateViewModel().hideChartLines(),
        }
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            this.getTemplateViewModel().isFromURL(true);
            this.getTemplateViewModel().articles(urlParams.articles);
            this.getTemplateViewModel().chartsRange(urlParams.chartsRange);

            let chartLines = urlParams.hideChartLines;
            if(!chartLines){
                chartLines = [];
            }
            this.getTemplateViewModel().hideChartLines(chartLines);
        }
    }

    public async onClick7DayView() {
        await this.caller.removeImagesInArticleContainers()

        this.getTemplateViewModel().chartsRange("week");
        this.caller.getChartData();
    }

    public async onClick1DayView() {
        await this.caller.removeImagesInArticleContainers()

        this.getTemplateViewModel().chartsRange("day");
        this.caller.getChartData();
    }

    public onClickRefresh(){

        this.caller.getChartData();
    }

    public setWatchlist(watchlist): Promise<void> {
        return new Promise(async (resolve, reject) => {
            this.getTemplateViewModel().watchlist([]);
            this.getTemplateViewModel().watchlist(watchlist);

            if (!watchlist || watchlist.length == 0) {
                this.getTemplateViewModel().watchlistEmpty(true);
            }

            let articles = [];
            for (let item of watchlist) {
                if (item.article) {
                    articles.push(item.article.id);
                }
            }

            this.getTemplateViewModel().articles(articles);

            if (this.getTemplateViewModel().articles().length > watchlist_template.REQUEST_BATCH_SIZE) {
                this.getTemplateViewModel().batches(chunkObservableArray(this.getTemplateViewModel().articles(), watchlist_template.REQUEST_BATCH_SIZE))
            } else {
                this.getTemplateViewModel().batches(chunkObservableArray(this.getTemplateViewModel().articles(), 0))
            }

            this.watchlistChart.setShowGrid(true);
            this.watchlistChart.setDate('date');
            this.watchlistChart.setMinGridDistance(20);

            if (this.getTemplateViewModel().chartsRange() == "day") {
                this.watchlistChart.setInterval([
                    {timeUnit: "hour", count: 1}
                ]);
            } else {
                this.watchlistChart.setInterval([
                    {timeUnit: "hour", count: 1}
                ]);
            }

            let yaxis = [];
            let linesToHide = this.getTemplateViewModel().hideChartLines();

            if (linesToHide.indexOf("viewCount") < 0) {
                yaxis.push({
                    field: "viewCount",
                    name: 'Views',
                    axis: "main",
                    color: "#6e3dbb",
                    opposite: false,
                    bullet: "none"
                });
            }

            if (linesToHide.indexOf("visitCount") < 0) {
                yaxis.push({
                    field: "visitCount",
                    name: 'Visits',
                    axis: "main",
                    color: "#009888",
                    opposite: false,
                    bullet: "none"
                });
            }

            if (linesToHide.indexOf("depthMarkerCount") < 0) {
                yaxis.push({
                    field: "depthMarkerCount",
                    name: 'Engagements',
                    axis: "main",
                    color: "#268af9",
                    opposite: false,
                    bullet: "none",
                    tooltipText: "{name}: [bold]{valueY} ({engagementRate}%)[/]",
                    calculatePercent: true
                });
            }

            this.watchlistChart.setYaxis(yaxis);
            let ranges = [];
            this.watchlistChart.setRanges(ranges);
            await this.watchlistChart.drawListCharts(watchlist);
            this.watchlistChart.show();

            // this.getTemplateViewModel().watchlist().forEach( watchlistItem => {
            //     this.setShortTermReport(watchlistItem)
            // })

            resolve();
        });
    }


    public onClickCreateShareUrl(){

        let url = this.getUrl();

        // Copy the text inside the text field
        window.navigator['clipboard'].writeText(url);

        // Alert the copied text
        this.caller.copyToClipboardAlert();
    }

    public getUrl(){

        let viewModelParams = this.getViewModelForRequest();

        // @ts-ignore
        let clonedViewModelParams = Object.assign({}, viewModelParams);

        //build the url

        let queryString = '';

        let firstParam = true;

        for(let key in clonedViewModelParams){

            let paramValue = clonedViewModelParams[key];

            if(paramValue == null){

                continue;
            }

            if(Array.isArray(paramValue)){
                if(paramValue.length == 0){
                    continue;
                }

                paramValue = JSON.stringify(paramValue);
                paramValue = encodeURIComponent(paramValue);
            }

            if(typeof paramValue === 'object'){

                paramValue = JSON.stringify(paramValue);
                paramValue = encodeURIComponent(paramValue);
            }

            if(typeof paramValue === 'function'){

                let functionValue = paramValue();
                if(functionValue){
                    paramValue = JSON.stringify(functionValue);
                    paramValue = encodeURIComponent(functionValue);
                }else{
                    continue;
                }
            }

            if(paramValue !== ""){

                if(firstParam){

                    queryString = queryString + key + '=' + paramValue;
                    firstParam = false;
                }else{

                    queryString = queryString + '&' + key + '=' + paramValue;
                }
            }
        }

        let rootPath = window.location.href.split('?')[0];
        let path = rootPath;

        if(queryString){
            path = rootPath + "?" + queryString;
        }

        return path;
    }

    public onClickRemoveFromWatchlist(data) {

        if (confirm("Are you sure you want to remove this from your watchlist?")) {

            let index = this.getTemplateViewModel().watchlist().findIndex(x => x.article.id == data.article.id);
            if(index != -1) {
                this.getTemplateViewModel().watchlist.splice(index, 1);
            }
            this.caller.removeFromWatchlist(data.article.id);
        }
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {

        //Do not drag
        if(this.getTemplateViewModel().isFromURL()){
            return;
        }
        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }

    public onClickViewArticle(data, event){
        if(event.target.id.indexOf("site-view") == -1){
            this.caller.viewArticle(data.article.id);
        }
    }

    public async toggleChartLines(data){

        let existingHideLines = this.getTemplateViewModel().hideChartLines();
        let index = existingHideLines.indexOf(data);

        //if it exists in list, remove it. Otherwise, add it. order is irrelevant
        if(index >= 0){
            existingHideLines.splice(index, 1);
        }else{
            existingHideLines.push(data);
        }

        this.getTemplateViewModel().hideChartLines(existingHideLines);
        await this.setWatchlist(this.getTemplateViewModel().watchlist());
    }

    public setShortTermReport(shortTermReport): void {

        this.shortTermReportChart.setDate('date');
        this.shortTermReportChart.setMinGridDistance(20);

        if(this.getTemplateViewModel().shortTermReportRange() == "day"){

            this.shortTermReportChart.setInterval([
                {timeUnit: "hour", count: 1}
            ]);
        }else{

            this.shortTermReportChart.setInterval([
                {timeUnit: "hour", count: 1}
            ]);
        }

        // set y axis
        let yaxis = [];

        yaxis.push({
            field: "viewCount",
            name:  'Views',
            axis: "main",
            color: "#6e3dbb",
            opposite: false,
            bullet: "none"
        });

        yaxis.push({
            field: "visitCount",
            name:  'Visits',
            axis: "main",
            color: "#009888",
            fillOpacity: 0.5,
            opposite: false,
            bullet: "none"
        });

        yaxis.push({
            field: "depthMarkerCount",
            name:  'Engagements',
            axis: "main",
            color: "#268af9",
            opposite: false,
            bullet: "none",
            tooltipText: "{name}: [bold]{valueY} ({engagementRate}%)[/]",
            calculatePercent: true
        });

        this.shortTermReportChart.setYaxis(yaxis);

        let ranges = [];
        //Get publish dates
        let publishDate = shortTermReport["publishDate"];
        if(publishDate){

            ranges = [{
                publishDate: publishDate,
                publishType: "first"
            }];

            let republishes = shortTermReport["republishDates"];
            republishes.forEach(item=>{
                if(item.republishDate){
                    ranges.push({publishDate: item.republishDate, publishType: "republish"});
                }
            });
        }

        this.shortTermReportChart.setRanges(ranges);

        this.shortTermReportChart.drawChart(shortTermReport["data"]);

        this.shortTermReportChart.show();
    }

    public onClick7DayViewSTR(){

        this.getTemplateViewModel().shortTermReportRange("week");
        this.caller.getShortTermReport(this.getTemplateViewModel().shortTermReportIdArticle());
        //this.resetCurrentBatch()
    }
    public onClick1DayViewSTR(){

        this.getTemplateViewModel().shortTermReportRange("day");
        this.caller.getShortTermReport(this.getTemplateViewModel().shortTermReportIdArticle());
    }
    public onClickRefreshSTR(){

        this.caller.getShortTermReport(this.getTemplateViewModel().shortTermReportIdArticle());
    }

    public onClickShowChart(data){

        let idArticle = data.article.id;

        this.getTemplateViewModel().shortTermReportIdArticle(idArticle);
        this.getTemplateViewModel().shortTermReportRange(this.getTemplateViewModel().chartsRange());

        this.setShortTermReport(data);

        document.getElementById('watchlist-chart-popup').classList.add('is-visible');
        document.body.classList.add('is-fixed');
    }

    public onClickHideChart(){

        this.getTemplateViewModel().shortTermReportIdArticle(null);
        document.getElementById('watchlist-chart-popup').classList.remove('is-visible');
        document.body.classList.remove('is-fixed');

        if(this.getTemplateViewModel().lastRefreshedCounter() > 0){
            this.onClickRefresh();
        }
    }

    public getAutoRefresh(){
        return this.autoRefresh
    }

    public incrCurrentBatch(){
        let inc = this.getTemplateViewModel().currentBatch()
        this.getTemplateViewModel().currentBatch(inc + 1)
    }

    public getCurrentBatch(){
        return this.getTemplateViewModel().currentBatch()
    }

    public resetCurrentBatch(){
        return this.getTemplateViewModel().currentBatch(0)
    }

    public getwatchlistChart(){
        return this.watchlistChart
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/watchlist_template.ts